import React from "react";

export function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-12 ${className}`}>{children}</div>;
}

export function SectionLabel({ children, light = false }) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] ${
        light ? "text-gold-light" : "text-gold"
      }`}
    >
      <span className={`h-px w-8 ${light ? "bg-gold-light/60" : "bg-gold/60"}`} />
      {children}
    </span>
  );
}
